import { atom } from 'jotai';
import { atomWithHash } from 'jotai-location';
import { atomFamily, atomWithStorage } from 'jotai/vanilla/utils';
import { ActualityMainViewType } from './actuality.types';
import { ActivityFeedTabId, FeedMenuItemId } from './feed.types';

const actualitySelectedMenuIdFamilyStorage = atomFamily((actualityId: string) =>
  atomWithStorage<FeedMenuItemId>(
    `actuality-menuId-${actualityId}`,
    'feed-menu-activity',
  ),
);

const actualitySelectedMenuIdHash = atomWithHash<FeedMenuItemId>(
  'menuId',
  null,
);

export const actualitySelectedMenuIdAtom = atomFamily((actualityId: string) =>
  atom(
    get =>
      get(actualitySelectedMenuIdHash) ??
      get(actualitySelectedMenuIdFamilyStorage(actualityId)),
    (_get, set, newValue: FeedMenuItemId) => {
      set(actualitySelectedMenuIdHash, newValue);
      set(actualitySelectedMenuIdFamilyStorage(actualityId), newValue);
    },
  ),
);

export const actualitySelectedTabIdAtom = atomWithHash<ActivityFeedTabId>(
  'tabId',
  'tab-feed-stats',
);

export const actualityMainViewTypeAtom = atomWithHash<ActualityMainViewType>(
  'view',
  'layout',
);
